import i18next from 'i18next';
import ProgressBar from '../../ProgressBar/ProgressBar';
import SspProviderContext from '../../../utils/SspProvider/context';
import { FullWidthButton } from '../../AutostadtTabComponents/Button';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import './styles.scss';
import type { AnimationEvent } from 'react';

const TIMEOUT = 3_000;

const resolveAfter = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

interface Props {
    introViewable: boolean;
    onEnded: () => void;
    onShowIntro: () => void;
}

export default function AppLoading(props: Props): JSX.Element {
    const store = useContext(SspProviderContext);
    const appReady = !!store.state.content;

    const [animate, setAnimate] = useState<boolean>(false);

    const containerElementRef = useRef<HTMLDivElement>(null);
    const coverElementRef = useRef<HTMLDivElement>(null);

    const handleShowIntro = useCallback(() => {
        props.onShowIntro();
    }, [props]);

    const handleAnimationEnd = useCallback((e: AnimationEvent) => {
        if ((e.target as HTMLElement).classList.contains('loading-app') && e.animationName === 'app-loading-fade-in' && !animate) {
            setAnimate(true);
        }
        if ((e.target as HTMLElement).classList.contains('loading-app-container') && e.animationName === 'app-loading-fade-out') {
            props.onEnded();
        }
        if ((e.target as HTMLElement).classList.contains('cover') && e.animationName === 'app-loading-fade-in') {
            containerElementRef.current?.classList.add('fade-out');
        }
    }, [animate, props]);

    useEffect(() => {
        (async function () {
            await resolveAfter(TIMEOUT);
            if (appReady) {
                coverElementRef.current?.classList.add('fade-in');
            }
        })();
    }, [appReady]);

    return (
        <div className='loading-app-container' ref={containerElementRef} onAnimationEnd={handleAnimationEnd}>
            <div className='loading-app' onAnimationEnd={handleAnimationEnd}>
                <div className='cover' ref={coverElementRef} onAnimationEnd={handleAnimationEnd}></div>
                <div className='logo'></div>
                <div className='top'>
                    <h1>{i18next.t('AppLoading')}</h1>
                </div>
                <div className='center'>
                    <ProgressBar
                        animate={animate}
                    />
                </div>
                {props.introViewable && <div className='bottom'>
                    <FullWidthButton
                        color='blue'
                        onClick={handleShowIntro}
                        text={i18next.t('IntroShow')}
                        type='secondary'
                    />
                </div>}
            </div>
        </div>
    );

}
